import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLenis } from "lenis/react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Problem from "@/components/sections/Problem";
import Solution from "@/components/sections/Solution";
import HowItWorks from "@/components/sections/HowItWorks";
import Settlement from "@/components/sections/Settlement";
import WhyBatEar from "@/components/sections/WhyBatEar";
import Founder from "@/components/sections/Founder";
import CaseStudy from "@/components/sections/CaseStudy";
import LocalServices from "@/components/sections/LocalServices";
import FAQ from "@/components/sections/FAQ";
import LeadMagnet from "@/components/sections/LeadMagnet";
import ContactCTA from "@/components/sections/ContactCTA";
import { WHATSAPP_URL } from "@/lib/api";

export default function Landing() {
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) window.__lenis = lenis;
  }, [lenis]);
  return (
    <main className="relative">
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <HowItWorks />
      <Settlement />
      <WhyBatEar />
      <Founder />
      <CaseStudy />
      <LocalServices />
      <FAQ />
      <LeadMagnet />
      <ContactCTA />
      <Footer />

      <motion.a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Message us on WhatsApp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.6, duration: 0.5, type: "spring" }}
        whileHover={{ scale: 1.08 }}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-black/30"
      >
        <MessageCircle size={26} />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      </motion.a>
    </main>
  );
}
